import { useState, useEffect, useRef } from 'react';
import styles from './index.module.scss';
import { useLocation } from 'react-router-dom'; 
import { format } from 'date-fns'; 
import { useAuth } from 'context/Auth'; 
import { listUserRentLogs, Logs1Type } from 'api/logs'; 
import { ReactComponent as PinDoneSVG } from 'assets/pin-done.svg';
import { ReactComponent as SortSVG } from "../../assets/icon-sort.svg";
import { useGlobalError } from 'context/Error/GlobalErrorContext';
import Dialog from 'components/Dialog';
import FamiShipQr from 'pages/Rent/FamiShipQr';

// PG-209 全家寄件單狀態文字
const FAMI_LABEL: Record<string, string> = {
  pending: '待交件',
  consigned: '已交件',
  expired: '已失效',
  failed: '要號失敗',
};

const ReturnHistory = () => {
  const { accessToken, me } = useAuth(); 
  const [filter, setFilter] = useState<'all' | 'self' | 'other'>('all');
  const [sort, setSort] = useState<'ascend' | 'descend'>('descend');
  // const [activeTab, setActiveTab] = useState<number>(0);
  const { pathname } = useLocation();
  const [logs, setLogs] = useState<Logs1Type[]>();
  const filterSelf = useRef<number>(2); // 2:all | 1:self | 0:other
  const sortRef = useRef<string>('descend'); 
  const { showError } = useGlobalError();
  // PG-209 重看全家寄件 QR
  const [qrItem, setQrItem] = useState<Logs1Type | null>(null);

  useEffect(() => {
    if(me !== undefined){
      fetchLogs();
    }
    // eslint-disable-next-line
  }, [pathname, me]);

  const fetchLogs = async () => {
    try {
      // 注意！要用「me?.id!」才能正常 work by Mike 21.12.17
      const { data } = await listUserRentLogs(
        accessToken!, 
        1, 
        me?.id!,
        filterSelf.current, 
        sortRef.current,
      );
      if (!data) {
        return 'Have not any return logs !!';
      } else {
        setLogs(data);
      }
    } catch (e: any) {
      console.log(e);
      showError(e, 'error')
    }
  };

  const formatDate = (dateStr: any, dateStr2: string) => {
    if (dateStr == null) {
      return dateStr2.slice(0,10); 
    }
    if (dateStr.indexOf('T') > 0) {
      let newDate = format(new Date(dateStr), 'yyyy-MM-dd');
      return newDate; 
    }
    return dateStr.slice(0,10); 
  };
  
  return (
    <div className={styles.history}>
      <div className={styles.filter}>
        <button
          className={filter === 'all' ? styles.active : undefined}
          onClick={() => {
            setFilter('all');
            filterSelf.current = 2;
            fetchLogs(); 
          }}
        >
          全部
        </button>
        <button
          className={filter === 'self' ? styles.active : undefined}
          onClick={() => {
            setFilter('self');
            filterSelf.current = 1;
            fetchLogs(); 
          }}
        >
          自己
        </button>
        <button
          className={filter === 'other' ? styles.active : undefined}
          onClick={() => {
            setFilter('other');
            filterSelf.current = 0;
            fetchLogs(); 
          }}
        >
          別人
        </button>
        <div className={styles.sort}>
          <button
            onClick={() => {
              setSort(sort === 'ascend' ? 'descend' : 'ascend');
              sortRef.current = sort === 'ascend' ? 'descend' : 'ascend';
              fetchLogs(); 
            }}
          >
            {sort === 'descend' ? '最新' : '最舊'}
            <SortSVG />
          </button>
        </div>
      </div>

      <div className={styles.list}>
        {logs?.map((item,inx) => (
          <div className={styles.listItem} key={inx}>
            <div className={`${styles.status} ${styles.done}`}>
              {/* 11/3小白修改 */}
              {/* <div className={styles.startDate}>
                <span>起始日</span>
                <span>{formatDate(item.shipping_at, item.created_at)}</span>
              </div> */}
              <div className={styles.expireDate}>
                <span>歸還日</span>
                <span>{formatDate(item.shipping_at, item.created_at)}</span>
                {/* <span>{formatDate(item.expired_at, item.overdue_at)}</span> */}
              </div>
              <div className={styles.line}>
                <PinDoneSVG />
              </div>
              {/* 11/3小白修改 */}
              {/* <div className={styles.expireDate}>
                <span>歸還日</span>
                <span>{formatDate(item.expired_at, item.overdue_at)}</span>
              </div> */}
            </div>
            <div className={styles.detail}>
              <div>
                <span>歸還地點</span>
                <span>
                  {item.channel_name}-{item.svpt_name}
                </span>
              </div>
              <div>
                {/* <span>類別</span>
                <span>{item.rentTypeName}</span> */}
                <span>包裝編號</span>
                <span>{item.epk_id}</span>
              </div>
              {item.fme_order?.order_no && (
                // PG-209 全家歸還:離開 QR 畫面後在這裡重看寄件編號,待交件可再開 QR
                <div>
                  <span>全家寄件編號</span>
                  <span>
                    {item.fme_order.order_no}
                    <span
                      style={{
                        marginLeft: 6,
                        fontSize: 11,
                        color: item.fme_order.flow_label === 'pending' ? '#c0392b' : '#888',
                      }}
                    >
                      {FAMI_LABEL[item.fme_order.flow_label] ?? ''}
                    </span>
                    {item.fme_order.flow_label === 'pending' && (
                      <button
                        type="button"
                        onClick={() => setQrItem(item)}
                        style={{
                          marginLeft: 8,
                          padding: '2px 10px',
                          background: '#008a45',
                          color: '#fff',
                          border: 'none',
                          borderRadius: 12,
                          fontSize: 12,
                          cursor: 'pointer',
                        }}
                      >
                        顯示 QR
                      </button>
                    )}
                    {item.fme_order.flow_label === 'expired' && (
                      <span style={{ display: 'block', fontSize: 11, color: '#888' }}>
                        請重新掃描包裝歸還取得新編號
                      </span>
                    )}
                  </span>
                </div>
              )}

              { filter === 'all' &&
                (
                  <>
                    <div>
                      <span>租借者</span>
                      <span>{item.renter_name ? item.renter_name  : '無租借者姓名'} - {item.renter_mobile}</span>
                    </div>
                    <div>
                      <span>歸還者</span>
                      <span>{item.return_name} - {item.mobile_number}</span>
                    </div>
                  </>
                )
              }
              { filter === 'self' &&
                (
                  <div>
                    <span>歸還者</span>
                    <span>{item.return_name} - {item.mobile_number}</span>
                  </div>
                )
              }
              { filter === 'other' && 
                (
                  <div>
                    <span>租借者</span>
                    <span>{item.renter_name} - {item.renter_mobile}</span>
                  </div>
                ) 
              }
              
              {/* 11/3小白修改 */}
              {/* <div>
                <span>金額</span>
                <span>{item.paid_amount}</span>
              </div> */}
              {/* <div>
                <span>付款方式</span>
                <span>{item.paidWayName}</span>
              </div> */}
            </div>
          </div>
        ))}
      </div>
      <span className={styles.tip}>僅顯示最近3個月內的記錄</span>
      <Dialog
        visible={qrItem !== null}
        onConfirm={() => setQrItem(null)}
        okText="關閉"
        message={
          qrItem?.fme_order?.order_no ? (
            <FamiShipQr orderNo={qrItem.fme_order.order_no} expiresAt={qrItem.fme_order.expires_at} compact />
          ) : (
            ''
          )
        }
      />
    </div>
  );
};

export default ReturnHistory;
